import React from "react";

import { css } from "@emotion/core";

import {
  Link,
  Text,
  Colors as ThemeColors,
  Typography,
} from "@zapier/design-system";

// Styles
import { headerCss, headingCss } from "@zapier/checkout/esm/utils/styles";

import { formatCompanyName } from "./formatCompanyName";

type Props = {
  accountName?: string | null | undefined;
  companyName?: string | null | undefined;
  heading: string;
  /** Set this to true when the change plan page appears inside an inline upgrade nudge. */
  isEmbeddedInInlineUpgrade?: boolean;
  subheading?: string;
};

const subHeadingCss = css`
  ${Typography.paragraph3};
  color: ${ThemeColors.neutral800};
  margin-top: 0.5em;
  text-align: center;
`;

export const ChangePlanHeader = (props: Props) => {
  const formattedCompanyName = formatCompanyName(props.companyName);

  const standardContent = props.subheading && (
    <div css={subHeadingCss}>
      {props.subheading}: <span>{props.accountName}</span>{" "}
      {formattedCompanyName}
    </div>
  );

  const inlineUpgradeHeaderContent = (
    <Text
      color="neutral700"
      tag="p"
      margin="15px"
      textAlign="center"
      type="smallPrint1Medium"
    >
      You&#39;re upgrading the account <span>{props.accountName}</span>
      {formattedCompanyName ? " " + formattedCompanyName : null}. Have questions
      about what&#39;s included in your plan?{" "}
      <Link href="/app/pricing">Compare plans and pricing</Link>.
    </Text>
  );

  return (
    <header css={headerCss}>
      <h1 css={headingCss}>{props.heading}</h1>
      {props.isEmbeddedInInlineUpgrade
        ? inlineUpgradeHeaderContent
        : standardContent}
    </header>
  );
};
